import React from "react";
import MuiCheckbox from "@material-ui/core/Checkbox";
import CheckboxUnchecked from "../../icons/CheckboxUnchecked";
import withStyles from "@material-ui/core/styles/withStyles";

function Checkbox({ checked, color, ...props } = props) {
  return (
    <MuiCheckbox
      checked={checked}
      // overrides MUIs default unchecked in-determined icon
      indeterminateIcon={checked ? undefined : <CheckboxUnchecked />}
      {...props}
    />
  );
}

let styles = theme => ({
  root: {
    color: theme.palette.grey[500],
    transition: `background-color ${theme.transitions.common.short}`,
    "&$disabled": {
      color: theme.palette.grey.light
    },
    "&$checked": {
      color: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: theme.palette.primary.hover
      }
    },
    "&:hover": {
      backgroundColor: theme.palette.primary.hover
    }
  },
  disabled: {
    "&$checked": {
      color: theme.palette.grey[400]
    }
  },
  checked: {}
});

export default withStyles(styles)(Checkbox);
